import React from 'react';
import { useLocation } from 'react-router-dom';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';

export default function SingleCard({ title, description, children, className }) {
  const location = useLocation();

  // Routes where vertical scroll should be disabled
  const noScrollRoutes = [
    '/login',
    '/create-account',
    '/reset-password',
    '/otp'
  ];

  const isNoScroll = noScrollRoutes.some((path) =>
    location.pathname.startsWith(path)
  ) || location.pathname.startsWith('/change-password/');

  return (
    <div className={`single-card-wrapper ${isNoScroll ? 'no-scroll' : ''}`}>
      <ScrollView
        height="100%"
        width="100%"
        className={`with-footer single-card ${className || ''}`}
      >
        <div className={`dx-card ${className || ''}`}>
          <div className="header">
            <div className="title">{title}</div>
            <div className="description">{description}</div>
          </div>
          {children}
        </div>
      </ScrollView>
    </div>
  );
}
